export default "__VITE_ASSET__8500f5e1__"